import React from 'react';
import './Test.css'
const Connecting = () => {
    return (
        <div className='load-main'>
            <div className='d-flex justify-content-center align-items-center'>
                <p>Connecting</p>
                <div className='dots ms-4'></div>
            </div>
        </div>
    );
};

export default Connecting;